import { render, staticRenderFns } from "./TeishutsuStatusPage.vue?vue&type=template&id=290961ec&scoped=true&"
import script from "./TeishutsuStatusPage.vue?vue&type=script&lang=ts&"
export * from "./TeishutsuStatusPage.vue?vue&type=script&lang=ts&"
import style0 from "./TeishutsuStatusPage.vue?vue&type=style&index=0&id=290961ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "290961ec",
  null
  
)

export default component.exports